import {ItemModelType} from "@stores/WorkspaceStore";
import {Item} from "../../@types/Item";
import {updateItemDB} from "./updateItem";
import { CrudServices } from "../../platform/services/types/ServiceDependencies";
import { UserSessionState } from "@stores/UserSessionState";

export const resetAcknowledgment = async (
    services: CrudServices,
    userState: UserSessionState,
    itemMST: ItemModelType | null
) => {
    if (!itemMST || !userState.currentUserId) {
        return;
    }

    itemMST.clearAcknowledgements();

    const fieldsToUpdate: Partial<Item> = {
        ackUpdatedBy: userState.currentUserId,
        acknowledgementRequired: false,
        acknowledgement: {},
    }

    await updateItemDB(services, userState.dsManager!, itemMST.workspaceId, itemMST.id, fieldsToUpdate);
}